/**
 * File extension that must NOT start with a dot
 * @example `jpg` | `png` | `pdf`
 */
type FileExtension<T extends string> = T extends `.${string}` ? never : T;

export function changeFileExtension<T extends string>(
  filename: string,
  newExtension: FileExtension<T>,
): string {
  return filename.replace(/\.[^.]+$/, `.${newExtension}`);
}
